<template>
  <div id="activity_r" v-loading="loading">
    <top></top>
    <div class="main">
      <div class="content">
        <img class="activity_r_icon" :src="status.icon" alt="" />
        <div class="activity_r_status" :class="status.type">
          {{
            examineStatus == 9
              ? status.text + "\n" + reject_reason
              : status.text
          }}
        </div>
        <div class="activity_r_button">
          <div class="declare_fillButton" @click="toModifyActivity">去编辑</div>
          <div class="declare_borderButton" @click="back">返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import { getActivityDetail } from "../../api/api";
export default {
  name: "activityReview",
  components: { top },
  created() {
    this.loading = true;
    this.activityId = this.$route.query.id;
    this.getDetail();
  },
  data() {
    return {
      loading: false,
      statusGroup: [
        {
          type: "resolve",
          status_code: 2,
          icon: require("../../assets/icon_status2.png"),
          text: "您的活动已通过审核！",
        },
        {
          type: "reject",
          status_code: 9,
          icon: require("../../assets/icon_status3.png"),
          text: "您的活动审核被驳回，驳回原因:",
        },
        {
          type: "pending",
          status_code: 1,
          icon: require("../../assets/icon_status1.png"),
          text: "您的活动正在审核中，请耐心等待",
        },
      ],
      status: {},
      activityId: "",
      reject_reason: "",
      examineStatus: "",
    };
  },
  methods: {
    async getDetail() {
      let obj = {
        id: this.activityId,
      };
      const res = await getActivityDetail(this.$qs.stringify(obj));
      if (res.code == 1) {
        this.examineStatus = res.data.examine_status;
        if (res.data.reject_reason === null) {
          this.reject_reason = "";
        } else {
          this.reject_reason = res.data.reject_reason;
        }
        this.statusGroup.forEach((item) => {
          if (item.status_code == this.examineStatus) {
            this.status = item;
          }
        });
        this.loading = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    toModifyActivity() {
      this.$router.push({
        path: "/activityDetail",
        query: {
          id: this.activityId,
        },
      });
    },
    back() {
      this.$router.push({
        path: "/activityList",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activity_r_icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 200px auto 0;
  display: block;
}
.activity_r_status {
  width: 865px;
  padding: 32px 20px;
  box-sizing: border-box;
  border-radius: 18px;
  line-height: 28px;
  font-size: 14px;
  text-align: center;
  margin: 20px auto 0;
  white-space: pre-line;
}
.resolve {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}
.reject {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}
.pending {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}
.activity_r_button {
  display: flex;
  width: 272px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100px;
  justify-content: space-between;
  align-items: center;
  > div:first-child {
    margin-right: 20px;
  }
}

@media screen and (max-width: 1660px) {
  .activity_r_icon {
    margin: 100px auto 0;
  }
}
</style>